var ExtensionModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.ExtensionId = ko.observable();
    that.Object_ObjectExtensionId = ko.observable();
    that.LocalizationKey = ko.observable();

    that.Attributes = ko.observableArray([]);

    //subData
    that.LastSelectedObjectValue = ko.observable(-1);
    that.SelectedExtensionObjectValueIds = ko.observableArray([]);

    //flags
    that.IsDisabled = ko.observable(false);
    that.IsExtension = ko.observable(true);

    that.SetSelectetExtension = function (extension) {
        if (extension)
            pageModelHndl.pProductModel.SelectedExtensionId = extension.ExtensionId();

        return true;
    };
};